import { create } from "zustand";
import { PersistOptions, persist } from "zustand/middleware";
import { produce } from "immer";
import CryptoJS from 'crypto-js';
import { AddressState, Address, initAddress } from "./initialState";

export const useAddressStore = create<AddressState>() (
  persist<AddressState>(
    (set, get) => ({
      addressInfo: CryptoJS.AES.encrypt(JSON.stringify(initAddress), process.env.NEXT_PUBLIC_HASH_CODE!).toString(),
      updateAddress: (addressInfo: Address) => {
        set(
          produce((draft: AddressState) => {
            const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(addressInfo), process.env.NEXT_PUBLIC_HASH_CODE!).toString();
            draft.addressInfo = encryptedUser;
          })
        )
      },
      getAddress: () => {
        const state = get();

        if (state.addressInfo.constructor === ({}).constructor) {
          set(
            produce((draft: AddressState) => {
              const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(state.addressInfo), process.env.NEXT_PUBLIC_HASH_CODE!).toString();
              draft.addressInfo = encryptedUser;
            })
          )

          return state.addressInfo;
        } else if (state.addressInfo.constructor === "text".constructor) {
          try {
            return JSON.parse(CryptoJS.AES.decrypt(state.addressInfo, process.env.NEXT_PUBLIC_HASH_CODE!).toString(CryptoJS.enc.Utf8));
          } catch (error) {
            return initAddress;
          }
        } else {
          return initAddress;
        }
      }
    }), {
      name: "address"
    } as PersistOptions<AddressState>
  )
)
